import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from 'react';

import { DataState } from './DataProvider';
import { fetchAgentInfo } from '../services/api';

const AgentContext = createContext();

export const AgentProvider = ({ children }) => {
  const [agentTree, setAgentTree] = useState({});
  const [agentDescriptions, setAgentDescriptions] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const { userGoogleId: accessToken } = DataState();

  const loadAgentInfo = useCallback(async () => {
    if (!accessToken) {
      setAgentTree({});
      setAgentDescriptions({});
      setIsLoading(false);
      return;
    }

    try {
      setError(null);
      setIsLoading(true);
      const response = await fetchAgentInfo(accessToken);
      setAgentTree(response.agent_tree || {});
      setAgentDescriptions(response.agent_descriptions || {});
    } catch (err) {
      setError('Failed to load agent info.');
    } finally {
      setIsLoading(false);
    }
  }, [accessToken]);

  useEffect(() => {
    loadAgentInfo();
  }, [loadAgentInfo, refreshTrigger]);

  const refreshAgentInfo = useCallback(() => {
    setRefreshTrigger((prev) => prev + 1);
  }, []);

  return (
    <AgentContext.Provider
      value={{
        agentTree,
        agentDescriptions,
        isLoading,
        error,
        refreshAgentInfo,
      }}
    >
      {children}
    </AgentContext.Provider>
  );
};

export const useAgent = () => useContext(AgentContext);
